import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  isAdmin: boolean = false;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    document.title = (ENV_PORTAL === 'fnabc') ? 'Apps & Solutions - Page Not Found' : 'AT&T Business Console - Page Not Found';  
    if(window.location.href.includes('admin')) {
      this.isAdmin = true;
    }else{
      this.isAdmin = false;
    }
  }

}
